export function setCookie(name, value, days) {
  let expires = '';
  if (days) {
    /* istanbul ignore next */
    const date = new Date();
    /* istanbul ignore next */
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    /* istanbul ignore next */
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '')  + expires + '; SameSite=Strict; path=/';
}

export function getCookie(name) {
  const nameEQ = name + '=';
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const trimmedCookie = cookie.trim(); // Remove leading spaces
    if (trimmedCookie.startsWith(nameEQ)) {
      return trimmedCookie.substring(nameEQ.length);
    }
  }
  return null;
}

export function eraseCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;';
}
